import { Link } from "react-router-dom";
import { Card, Col, Row } from "reactstrap";
import SweetAlert from "sweetalert2";
import { Href } from "../../../../../../constants";
import { useAppDispatch, useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { setBookmark, setEditModal, setEditRow, setRemoveBookmark } from "../../../../../../reduxToolkit/reducers/bookmarkTabsSlice";
import { BookmarkItems } from "../../../../../../types/Applications";
import { dynamicImage } from "../../../../../../utils";
import DescriptionData from "./DescriptionData";
import SearchNotFoundClass from "../../../../../../coreComponents/SearchNotFoundClass";
import { Image } from "../../../../../../coreComponents/Image";

// This component renders a list of bookmarked items, allowing users to add, remove, edit or delete them.

const DataList = () => {
  const { bookmark } = useAppSelector((state) => state.bookmarkTab);
  const dispatch = useAppDispatch();
  const addToFavorites = (data: BookmarkItems) => {
    if (data.fillStar === false) {
      const newBookmarkItems = bookmark.map((item) => (item.id === data.id ? { ...item, fillStar: true } : item));
      dispatch(setBookmark(newBookmarkItems));
    } else {
      const newBookmarkItems = bookmark.map((item) => (item.id === data.id ? { ...item, fillStar: false } : item));
      dispatch(setBookmark(newBookmarkItems));
    }
  };

  const onHandleClick = (data: BookmarkItems) => {
    dispatch(setEditModal());
    dispatch(setEditRow(data));
  };

  const removeFromBookmark = (bookmarkId: number) => {
    SweetAlert.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "cancel",
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        dispatch(setRemoveBookmark(bookmarkId));
        SweetAlert.fire("Deleted!", "Your file has been deleted.", "success");
      } else {
        SweetAlert.fire("Your imaginary file is safe!");
      }
    });
  };

  return (
    <Row id="BookmarkItems">
      {/* Mapping through bookmark to display bookmarks in the form of cards */}
      {bookmark.length > 0 ? (
        bookmark.map((data, index) => (
          <Col xxl="3" md="4" key={index}>
            <Card className="bookmark-card">
              <div className="details-website">
                <Image className="img-fluid" src={dynamicImage(`${data.image}`)} alt="image" />
                <div className={`favourite-icon ${data.fillStar ? "favourite" : ""}`} onClick={() => addToFavorites(data)}>
                  <Link to={Href}>
                    <i className="fa fa-star" />
                  </Link>
                </div>
                <DescriptionData data={data} onHandleClick={onHandleClick} removeFromBookmark={removeFromBookmark} />
              </div>
            </Card>
          </Col>
        ))
      ) : (
        <SearchNotFoundClass word="Bookmark" />
      )}
    </Row>
  );
};

export default DataList;
